import { defineStyleConfig } from "@chakra-ui/react";

// Variante "compact" no padrão Rede Frota - Cardan: header cinza bem claro,
// texto cinza pequeno, linhas com MENOS padding horizontal (8px) para as
// linhas ocuparem menos espaço. É opt-in (só aplica em quem passa
// variant="compact"), preservando as tabelas de Precos/Resultado/modais.
//
// Todo o padding vive aqui (não usamos size="sm") para que o valor de 8px
// não seja sobrescrito pelo padding embutido do tamanho do Chakra.
const Table = defineStyleConfig({
  variants: {
    compact: {
      table: {
        fontFamily: "body",
      },
      thead: {
        bg: "neutrals.background.weak-50",
      },
      th: {
        px: "8px",
        py: "10px",
        fontSize: "11px",
        fontWeight: "600",
        color: "neutrals.text.sub-600",
        fontFamily: "body",
        textTransform: "none",
        letterSpacing: "0",
        borderBottom: "1px solid",
        borderColor: "neutrals.stroke.soft-200",
      },
      td: {
        px: "8px",
        py: "10px",
        fontSize: "13px",
        color: "neutrals.text.strong-950",
        fontFamily: "body",
        borderBottom: "1px solid",
        borderColor: "neutrals.stroke.soft-200",
      },
      tbody: {
        tr: {
          transition: "background 0.1s",
          _hover: { bg: "neutrals.background.weak-50" },
          "&:last-of-type td": { borderBottom: "none" },
        },
      },
    },
  },
});

export default Table;
